export const grid = {
  gap: {
    scale: 'space',
  },
  columnGap: {
    scale: 'space',
  },
  rowGap: {
    scale: 'space',
  },
  gridArea: {
    scale: true,
  },
  gridAutoColumns: {
    scale: 'space',
  },
  gridAutoFlow: {
    scale: true,
  },
  gridAutoRows: {
    scale: 'space',
  },
  gridColumn: {
    scale: true,
  },
  gridColumnEnd: {
    scale: true,
  },
  gridColumnGap: {
    scale: 'space',
  },
  gridColumnStart: {
    scale: true,
  },
  gridGap: {
    scale: 'space',
  },
  gridRow: {
    scale: true,
  },
  gridRowEnd: {
    scale: true,
  },
  gridRowGap: {
    scale: 'space',
  },
  gridRowStart: {
    scale: true,
  },
  gridTemplate: {
    scale: true,
  },
  gridTemplateAreas: {
    scale: true,
  },
  gridTemplateColumns: {
    scale: 'space',
  },
  gridTemplateRows: {
    scale: 'space',
  },
} as const;
/**
 * NextJS 12.2.5 does not support `satisfies` assertion
 * Once we upgrade NextJS, these should be `as const satisfies ScaleObject`
 */

export type Grid = typeof grid;
